import React, { useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box, Loader, Stack } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import * as User from '@/components/User';
import { UpdateUserInput } from '@/types/schema';

import {
  LearnerEditProfileDetailsFragment,
  useLearnerEditProfileDetailsQuery,
} from '../../graphql/queries/generated/learnerEditProfileDetails';
import Form from './Form';

interface EditLearnerDialogProps {
  learnerId: string;
  onClose: () => void;
  onSubmit: (values: UpdateUserInput) => void;
  isSubmitting: boolean;
}

const AVATAR_CLASSES = { border: 'border-4 border-solid border-bg-primary' };

const EditLearnerDialog = (props: EditLearnerDialogProps) => {
  const { learnerId, onClose, onSubmit, isSubmitting } = props;
  const [{ data, fetching, stale }] = useLearnerEditProfileDetailsQuery({
    variables: { learnerId },
  });
  const learner = data?.user as LearnerEditProfileDetailsFragment | undefined;
  const { t } = useTranslation();
  const [formikSubmit, setFormikSubmit] = useState<any>();

  const isLoading = fetching || stale || !learner;

  return (
    <Modal
      open
      action={{ text: t('Common:Actions.Save'), onSubmit: formikSubmit, isSubmitting }}
      header={{ title: t('Common:EditProfile') }}
      variant={ModalVariant.FullHeight}
      onClose={onClose}>
      {isLoading ? (
        <Stack alignItems="center" className="h-full w-full flex-1" justifyContent="center">
          <Loader />
        </Stack>
      ) : (
        <Stack className="overflow-auto py-0 px-0 pt-8" direction="col">
          <User.Provider className="px-24" user={learner as any}>
            <User.ProfilePicture className="ms-4" classes={AVATAR_CLASSES} size={128} />
          </User.Provider>
          <Box className="p-32">
            <Form learner={learner} setFormikSubmit={setFormikSubmit} onSubmit={onSubmit} />
          </Box>
        </Stack>
      )}
    </Modal>
  );
};

export default EditLearnerDialog;
